module.exports = __webpack_public_path__ + "img/payhere_logo.d8a07c82.png";